import React, { Component } from 'react';
import PropTypes from 'prop-types';
import iconInsurance from '../../Assets/Images/icon-insurance.svg';
import Icon from '../Icon';
import ButtonCollapse from '../ButtonCollapse';
import { eventPropType } from '../../Constants/eventTypes';
import CurrencyHelper from '../../Helpers/CurrencyHelper';
import DollarsAndCents from '../DollarsAndCents';
import Debounce from '../../Helpers/Debounce';
import Purchase from './Purchase';
import SummaryTable from './SummaryTable';
import ModalCertificateHolders from './ModalCertificateHolders';
import { Button } from '@jauntin/react-ui';
import ModalSaveQuote from '../ModalSaveQuote/ModalSaveQuote';

let isMobile = false;
let lastScrollTop = null;
const debounce = new Debounce({ period: 300 });

class Summary extends Component {
  constructor() {
    super();
    this.state = {
      showCertHoldersModal: false,
      showModalSaveQuote: false,
    };
  }

  componentDidMount() {
    const { mobileDisplay } = this.props;
    isMobile = mobileDisplay;

    if (isMobile) {
      window.addEventListener('scroll', (e) => {
        debounce.do(this.handleScroll, e.target.scrollingElement);
      });
      this.updateHeight();
    }
  }

  componentDidUpdate(prevProps) {
    const currentHeight = this.summaryElement.clientHeight;
    if (isMobile && prevProps.summHeight !== currentHeight) {
      this.updateHeight();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  updateHeight = () => {
    const { summaryHeightAction } = this.props;
    const height = this.summaryElement.clientHeight;
    summaryHeightAction(height);
  };

  handleScroll = (element) => {
    const { summaryIsOpen, mobileShow, toggleSummaryMobileAction } = this.props;
    const yPos = element.scrollTop;
    const distance = yPos - lastScrollTop;

    if (lastScrollTop === null || lastScrollTop === 0) {
      toggleSummaryMobileAction(true);
    } else if (lastScrollTop !== yPos && !summaryIsOpen) {
      if (distance > 10 && mobileShow) {
        // Down, hide summary
        toggleSummaryMobileAction(false);
      } else if ((distance < -20 || yPos < 100) && !mobileShow) {
        // Up, show summary
        toggleSummaryMobileAction(true);
      }
    }

    lastScrollTop = yPos;
  };

  handleCloseCertHolderModal = () =>
    this.setState({ showCertHoldersModal: false });

  handleShowCertHolderModal = () =>
    this.setState({ showCertHoldersModal: true });

  handleShowModalSaveQuote = () => this.setState({ showModalSaveQuote: true });

  handleCloseModalSaveQuote = () =>
    this.setState({ showModalSaveQuote: false });

  render() {
    const {
      eventType,
      toggleSummaryAction,
      summaryIsOpen,
      checkoutShow,
      checkoutEnabled,
      checkoutAction,
      total,
      purchaseShow,
      certHolders,
      validVenueAddress,
      hasVenueCodeReferral,
    } = this.props;
    const { showCertHoldersModal, showModalSaveQuote } = this.state;

    return (
      <div
        className="summary card mt-3 mt-lg-0"
        ref={(summaryElement) => {
          this.summaryElement = summaryElement;
        }}
      >
        <div className="summary__logo">
          <Icon image={eventType.selectionIcon || undefined} lg />
        </div>
        <div className="card-body summary__card-body">
          <div className="d-lg-none">
            <ButtonCollapse
              clickFunction={toggleSummaryAction}
              showList={summaryIsOpen}
              title={`${eventType.name} Insurance Policy`}
            />
          </div>
          <div className="form-row mt-lg-4 d-none d-lg-flex">
            <div className="col-auto">
              <img
                src={iconInsurance}
                alt="Insurance icon"
                className="icon--insurance"
              />
            </div>
            <div className="col">
              <h4 className="summary__title">{eventType.name}</h4>
              <h5>Event Insurance Policy</h5>
            </div>
          </div>

          <ModalCertificateHolders
            show={showCertHoldersModal}
            handleClose={this.handleCloseCertHolderModal}
            isMobile={isMobile}
            validVenueAddress={validVenueAddress}
            certHolders={certHolders}
            hasVenueCodeReferral={hasVenueCodeReferral}
          />

          {summaryIsOpen && (
            <SummaryTable
              {...this.props}
              handleShow={() => this.handleShowCertHolderModal()}
            />
          )}

          {checkoutShow && (
            <>
              <div className="form-row mb-2 pt-2 mt-2 border-top">
                <div className="col font-weight-bold">Total</div>
                <div className="col-auto font-weight-bold">
                  <DollarsAndCents
                    currency={new CurrencyHelper()
                      .setValue(total)
                      .convertFromInt()}
                  />
                </div>
              </div>
              <Button
                onClick={() => {
                  this.handleShowModalSaveQuote();
                }}
                text="Save quote"
                className="d-block mt-3 w-100 btn-primary"
                show={checkoutEnabled}
              />
              <Button
                disabled={!checkoutEnabled}
                onClick={checkoutAction}
                text="Checkout"
                className="d-block mt-3 w-100 btn--summary"
                show={checkoutEnabled}
              />
              <ModalSaveQuote
                show={showModalSaveQuote}
                handleClose={() => {
                  this.handleCloseModalSaveQuote();
                }}
              />
            </>
          )}
          {purchaseShow && (
            <Purchase {...this.props} show={purchaseShow} total={total} />
          )}
        </div>
      </div>
    );
  }
}

Summary.propTypes = {
  checkoutEnabled: PropTypes.bool.isRequired,
  checkoutShow: PropTypes.bool.isRequired,
  checkoutAction: PropTypes.func.isRequired,
  consentEnabled: PropTypes.bool.isRequired,
  purchaseEnabled: PropTypes.bool.isRequired,
  purchaseShow: PropTypes.bool.isRequired,
  purchaseAction: PropTypes.func.isRequired,
  eventType: eventPropType.isRequired,
  coverage: PropTypes.string.isRequired,
  basicCoverageConfirmed: PropTypes.bool.isRequired,
  eventDates: PropTypes.arrayOf(PropTypes.string).isRequired,
  eventFrequency: PropTypes.string.isRequired,
  daysOfWeek: PropTypes.arrayOf(PropTypes.number).isRequired,
  eventTotalGuests: PropTypes.string.isRequired,
  aboutEventConfirmed: PropTypes.bool.isRequired,
  eventPerformersCount: PropTypes.string.isRequired,
  eventGoods: PropTypes.string.isRequired,
  eventFood: PropTypes.string.isRequired,
  eventExhibition: PropTypes.string.isRequired,
  sellingLiquor: PropTypes.bool.isRequired,
  additionalCoveragesConfirmed: PropTypes.bool.isRequired,
  summaryIsOpen: PropTypes.bool.isRequired,
  toggleSummaryAction: PropTypes.func.isRequired,
  total: PropTypes.number.isRequired,
  summaryHeightAction: PropTypes.func.isRequired,
  summHeight: PropTypes.number.isRequired,
  toggleSummaryMobileAction: PropTypes.func.isRequired,
  mobileShow: PropTypes.bool.isRequired,
  mobileDisplay: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  validVenueAddress: PropTypes.bool.isRequired,
  certHolders: PropTypes.arrayOf(PropTypes.string).isRequired,
  hasVenueCodeReferral: PropTypes.bool.isRequired,
  isGettingCertHolders: PropTypes.bool.isRequired,
};

export default Summary;
